<template>
    <Teleport to="body">
        <div v-if="modelValue" class="ds-confirm-overlay">
            <!-- Подложка — сосед карточки: вложенный backdrop-filter не размывал бы график под карточкой. -->
            <div class="ds-glass-scrim" @click="handleCancel"></div>
            <div class="ds-glass-dialog ds-confirm-dialog">
                <div class="ds-glass-dialog-title">{{ title }}</div>
                <div v-if="text" class="ds-glass-dialog-text">{{ text }}</div>
                <div class="ds-glass-dialog-actions">
                    <button class="ds-glass-btn ds-glass-btn-secondary" type="button" @click="handleCancel">
                        {{ cancelText }}
                    </button>
                    <button class="ds-glass-btn ds-glass-btn-primary" type="button" @click="handleConfirm">
                        {{ confirmText }}
                    </button>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
interface Props {
    title: string
    text?: string
    confirmText?: string
    cancelText?: string
}

withDefaults(defineProps<Props>(), {
    confirmText: 'Подтвердить',
    cancelText: 'Отмена',
})

const modelValue = defineModel<boolean>({ required: true })

const emit = defineEmits<{
    confirm: []
    cancel: []
}>()

const handleConfirm = () => {
    modelValue.value = false
    emit('confirm')
}

const handleCancel = () => {
    modelValue.value = false
    emit('cancel')
}
</script>
